import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { partial } from '../../../util/translation/translation';

// The club crest stand-in in the card's corner
const Crest = () => (
  <svg className="tier-card__crest" viewBox="0 0 24 28" aria-hidden>
    <path
      d="M12 1 L23 5 V13 C23 20 18 25 12 27 C6 25 1 20 1 13 V5 Z"
      fill="none"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M12 8 l2 4.5 4.8.4-3.7 3.1 1.2 4.7L12 18.2 7.7 20.7l1.2-4.7-3.7-3.1 4.8-.4z"
      fill="white"
    />
  </svg>
);

/**
 * A tier's membership card as the app shows it, with example values. The
 * tier's card background when there is one, else a plain colour.
 */
const TierCardPreview = ({ name, background, variant, layout }) => {
  const s = partial('shared');
  const className = `tier-card tier-card--${layout}${
    background ? '' : ` tier-card--plain tier-card--${variant}`
  }`;
  const style = background
    ? { backgroundImage: `url(${background})` }
    : undefined;
  const valid = (
    <span className="tier-card__live">
      <i />
      {s('tierCardValid')}
    </span>
  );

  // As on the member's tier page: their name and "Valid" (the tier's name
  // goes under the card)
  if (layout === 'flow') {
    return (
      <div className={className} style={style}>
        <div className="tier-card__bottom">
          <strong className="tier-card__member">John Doe</strong>
          {valid}
        </div>
      </div>
    );
  }

  return (
    <div className={className} style={style}>
      <div className="tier-card__top">
        <Crest />
        {valid}
      </div>
      <span className="tier-card__name">{name}</span>
      <div className="tier-card__bottom">
        <span className="tier-card__field">
          <span>{s('tierCardMember')}</span>
          <strong>John Doe</strong>
        </span>
        <span className="tier-card__field">
          <span>{s('tierCardValidUntil')}</span>
          <strong>{moment().add(1, 'year').format('D MMM YYYY')}</strong>
        </span>
      </div>
    </div>
  );
};

TierCardPreview.propTypes = {
  name: PropTypes.string,
  background: PropTypes.string,
  // Colour without a background image: gold, or platinum
  variant: PropTypes.oneOf(['gold', 'platinum']),
  // full: crest, name, member and date (the tier form); flow: the member
  // and "Valid" only (the upgrade flow, with the name under the card)
  layout: PropTypes.oneOf(['full', 'flow']),
};

TierCardPreview.defaultProps = {
  name: '',
  background: null,
  variant: 'gold',
  layout: 'full',
};

export default TierCardPreview;
